import { AxiosResponse } from "axios";
import axiosApi from "@/api/axios-api";

export default {
    noticeMessageGet(request: any): Promise<AxiosResponse<any>> {
        return new Promise((resolve, reject) => {
            axiosApi.axiosPost(`/notice/getnoticemessage`, request)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }
}